module.exports = __webpack_public_path__ + "img/substituicao1.f5f6a91b.png";